import HeaderTable from '@/fsd/shared/ui/HeaderTable/HeaderTable';
import HeaderTableItem from '@/fsd/shared/ui/HeaderTableItem';
import { observer } from 'mobx-react-lite';
import RemainsStore from '../../model/store/RemainsStore';

const RemainsTableHeader = observer(() => {
  const { columns } = RemainsStore;

  return (
    <HeaderTable additionalClass="blueHeader" fixed={true}>
      {columns.map((column) =>
        column.isVisible ? (
          <HeaderTableItem
            key={column.id}
            name={column.label}
            style={{ width: `${column.width}px` }}
            additionalClass={
              (column.type === 'count' ||
                column.type === 'pay' ||
                column.type === 'warehouse') &&
              'alightAmountHeader'
            }
          />
        ) : null
      )}
    </HeaderTable>
  );
});

export default RemainsTableHeader;
